// file src/constants/QUESTION_TOPIC.constants.ts
export const questionTopicConstants = {
    GETALL_REQUEST: 'QUESTION_TOPICS_GETALL_REQUEST',
    GETALL_SUCCESS: 'QUESTION_TOPICS_GETALL_SUCCESS',
    GETALL_FAILURE: 'QUESTION_TOPICS_GETALL_FAILURE',
  
    DELETE_REQUEST: 'QUESTION_TOPIC_DELETE_REQUEST',
    DELETE_SUCCESS: 'QUESTION_TOPIC_DELETE_SUCCESS',
    DELETE_FAILURE: 'QUESTION_TOPIC_DELETE_FAILURE',

    CREATE_REQUEST: 'QUESTION_TOPIC_CREATE_REQUEST',
    CREATE_SUCCESS: 'QUESTION_TOPIC_CREATE_SUCCESS',
    CREATE_FAILURE: 'QUESTION_TOPIC_CREATE_FAILURE',

    UPDATE_REQUEST: 'QUESTION_TOPIC_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'QUESTION_TOPIC_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'QUESTION_TOPIC_UPDATE_FAILURE',
};